
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "id": "图层_1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "x": "0px",
    "y": "0px",
    "width": "17px",
    "height": "17px",
    "viewBox": "0 0 17 17",
    "enable-background": "new 0 0 17 17",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "id": "订单",
        "transform": "translate(-1062 -664)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "订单_1_",
            "fill": "#FFFFFF",
            "d": "M1072.333,665h-3.67c-0.826,0-1.551,0.549-1.775,1.344v0.006h-0.681\n\t\tc-1.219,0-2.207,0.988-2.207,2.207l0,0v9.728c0,1.219,0.988,2.207,2.207,2.207l0,0h8.591c1.22,0,2.207-0.988,2.207-2.207l0,0\n\t\tv-9.728c0-1.219-0.987-2.207-2.207-2.207l0,0h-0.681v-0.006c-0.225-0.796-0.951-1.346-1.779-1.344H1072.333z M1074.791,667.441\n\t\tc0.617,0,1.117,0.5,1.117,1.117l0,0v9.742c-0.01,0.61-0.506,1.1-1.116,1.101h-8.6c-0.61-0.01-1.1-0.506-1.1-1.116v-9.745\n\t\tc0.009-0.61,0.506-1.1,1.116-1.1h0.691v0.006c0.236,0.778,0.953,1.309,1.765,1.309h3.67c0.813,0,1.529-0.531,1.766-1.309v-0.006\n\t\tL1074.791,667.441z M1072.091,674.4h-3.185c-0.301,0-0.545,0.244-0.545,0.545v0.035c0,0.301,0.244,0.545,0.545,0.545h3.185\n\t\tc0.302,0,0.545-0.244,0.545-0.545v-0.035C1072.636,674.645,1072.393,674.4,1072.091,674.4z M1072.091,671.18h-3.185\n\t\tc-0.301,0-0.545,0.244-0.545,0.545v0.035c0,0.301,0.244,0.545,0.545,0.545h3.185c0.302,0,0.545-0.244,0.545-0.545v-0.035\n\t\tC1072.636,671.424,1072.393,671.18,1072.091,671.18z M1072.333,666.091c0.416,0,0.753,0.337,0.753,0.753l0,0v0.082\n\t\tc-0.006,0.411-0.342,0.741-0.753,0.741h-3.682c-0.411-0.006-0.741-0.342-0.741-0.753v-0.082c0.006-0.411,0.342-0.741,0.753-0.741\n\t\tH1072.333z"
          }
        }
      ]
    }
  ]
})
    }
  